export class EventTrace extends Error {
    listener;
    data;
    func;
    event;
    stack;
}
export const traceStackFilterRgx = new RegExp(`(${[
    'node_modules',
    'node:internal',
    '$spy',
    'makeEventTracer',
    'sendToSpy',
    'Function.spy',
    'Observable.Engine'
].join('|')})`);
export class EventError extends Error {
    event;
    listener;
    data;
    constructor(message, opts){
        super(message);
        this.event = opts?.event;
        this.listener = opts?.listener;
        this.data = opts?.data;
    }
}
export const isEventError = (err)=>{
    return err instanceof EventError;
};
export class EventPromise extends Promise {
    cleanup;
    reject;
    resolve;
}
export const makeEventTracer = (event, caller, listenerOrData)=>{
    const err = new Error();
    const split = err.stack.split('\n');
    split.shift();
    const filtered = split.filter((line)=>!traceStackFilterRgx.test(line));
    const message = `EventStack (${event} ${caller.toString()}):`;
    filtered.unshift(message);
    const stack = filtered.join('\n');
    const tracer = new EventTrace(message);
    tracer.name = message;
    tracer.func = caller;
    tracer.event = event;
    tracer.stack = stack;
    tracer.listener = null;
    tracer.data = null;
    if (typeof listenerOrData === 'function') {
        tracer.listener = listenerOrData;
    } else {
        tracer.data = listenerOrData;
    }
    return tracer;
};
export const rgxStrToRgx = (rgxStr)=>{
    const split = rgxStr?.replace(/^\//, '').split('/');
    const flags = split.pop();
    const expr = split.join('/');
    return RegExp(expr, flags);
};
export const arrOfMatchingValues = (vals, map)=>{
    const listeners = [];
    for (const key of vals){
        for (const fn of map.get(key) || new Set()){
            listeners.push({
                event: key,
                func: fn
            });
        }
    }
    return listeners;
};
export var InternalEvs = /*#__PURE__*/ function(InternalEvs) {
    InternalEvs["on"] = "on";
    InternalEvs["off"] = "off";
    InternalEvs["emit"] = "emit";
    InternalEvs["clear"] = "clear";
    return InternalEvs;
}({});
export class InternalEvent extends Event {
    type;
    data;
    constructor(ev, data){
        super(ev);
        this.data = data;
        this.type = ev;
    }
}
export const validateEvent = (fn, opts)=>{
    if (opts.event === undefined || typeof opts.event !== 'string' && opts.event instanceof RegExp === false) {
        throw new EventError(`observer.${fn}: Event must be a string or RegExp`, opts);
    }
};
export const validateListener = (fn, opts)=>{
    if (opts.listener !== undefined && typeof opts.listener !== 'function') {
        throw new EventError(`observer.${fn}: Listener must be a function`, opts);
    }
};
